import yup from '@/init/yup';
import { PORTAL_USE_TYPE } from '@/types/types';
import { InferType } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const SigninSchema = yup.object({
  user_id: yup.string().required('必須です'),
  password: yup.string().required('必須です'),
  device_hash: yup.string(),
  use_type: yup
    .mixed<PORTAL_USE_TYPE>()
    .oneOf(Object.values(PORTAL_USE_TYPE))
    .required(),
});
export type SigninType = InferType<typeof SigninSchema>;
export const SigninResolver = yupResolver(SigninSchema);
